/** Query param carried into the viewer recording which screen opened it. */
export var VIEWER_ORIGIN_PARAM = "from";

/** Origin marker identifying the patient channel route (`/patients-v2/[patientId]`). */
export var PATIENT_CHANNEL_ORIGIN = "patients-v2";

/** Minimal router shape needed to read the viewer-origin query param. */

/** Reads the screen the viewer was opened from, so the back action can return there. */
export function getViewerOrigin(router) {
  var _router$query;
  return (router === null || router === void 0 || (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query[VIEWER_ORIGIN_PARAM]) === PATIENT_CHANNEL_ORIGIN ? PATIENT_CHANNEL_ORIGIN : "";
}

/** Carries the origin marker across viewer-internal navigations that rebuild the URL. */
export function appendViewerOrigin(url, origin) {
  if (!origin) return url;
  return "".concat(url).concat(url.includes("?") ? "&" : "?").concat(VIEWER_ORIGIN_PARAM, "=").concat(origin);
}

/** Tags a viewer URL as opened from the patient channel so the viewer's back action returns there. */
export function withPatientChannelOrigin(url) {
  return appendViewerOrigin(url, PATIENT_CHANNEL_ORIGIN);
}